import type { LinkProps } from '../@types';

/**
 * Checks if provided url is external.
 *
 */
export function getPathname(to: LinkProps['to']) {
  if (typeof to === 'string') {
    return to;
  }

  return to?.pathname || '';
}
